import React, { useState } from 'react'
import BaseHome from '../../Home/BaseHome'
import TabPanelSolid, { TabPanel } from '../../Common/TabPanelSolid'
import ManageDetails from './ManageDetails'
import ManageLeaderboard from './ManageLeaderboard'
import ManageRules from './ManageRules'
import { useParams } from 'react-router'
import { t } from 'i18next'
import CancelScrimPopup from "../../Popup/CancelScrim";

const ManageScrim = () => {
  const tabs = [t("private_contest.details"), t("private_contest.leaderboard"), t("private_contest.rules")]
  const [value, setValue] = useState(0)
  const { id } = useParams();
  const [scrim, setScrim] = useState(null)
  const [isCancelPopup, setIsCancelPopup] = useState(false);

  const getTabs = (val,index,activeTab) =>{
    return (
      <TabPanel className="rewards-body" value={val} index={index}>
          {/* <LeaderboardBox style={style} style1={style1} /> */}
          <div className='scroll-none '>
          {
            index == 0 ? <ManageDetails scrimId={id} setScrim={setScrim} setIsCancelPopup={setIsCancelPopup} /> :
            index == 1 ? <ManageLeaderboard scrimId={id} scrim={scrim} setScrim={setScrim}/>
            : <ManageRules scrimId={id} scrim={scrim}/>

          }
  
          </div>
        </TabPanel>
    )
  }
  return (
    <BaseHome title = {t("private_contest.manage_your_contest")}>
      <TabPanelSolid tabs={tabs} value={value} setValue = {setValue} getTabs={getTabs} />

      {isCancelPopup && (
          <CancelScrimPopup
            isOpen={isCancelPopup}
            title={t('private_contest.cancel_contest')}
            onClose={() => setIsCancelPopup(false)}
            scrimId={id}
          />
      )}
    </BaseHome>
  )
}

export default ManageScrim